import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Tooltip from '@mui/material/Tooltip';
import { keyframes } from '@mui/system';

const pop = keyframes`
  0% { transform: scale(0.85); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
`;

const STAR_COLOR = '#f59e0b';

/**
 * Estrella "me interesa" — no es favorito social.
 */
export default function CatalogInterestStar({
  active = false,
  disabled = false,
  size = 'small',
  onClick,
  sx,
  justSaved = false,
}) {
  return (
    <Tooltip title={active ? 'Quitar de tus intereses' : 'Me interesa'} enterTouchDelay={400}>
      <IconButton
        size={size}
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onClick?.(e);
        }}
        aria-label={active ? 'Quitar interés' : 'Me interesa'}
        sx={{
          bgcolor: 'rgba(255,255,255,0.92)',
          boxShadow: '0 2px 8px rgba(0,0,0,.12)',
          '&:hover': { bgcolor: '#fff' },
          animation: justSaved ? `${pop} 0.35s ease` : 'none',
          ...sx,
        }}
      >
        {active ? (
          <StarIcon sx={{ color: STAR_COLOR, fontSize: size === 'medium' ? 26 : 22 }} />
        ) : (
          <StarBorderIcon sx={{ color: STAR_COLOR, fontSize: size === 'medium' ? 26 : 22 }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
